module.exports = __webpack_public_path__ + "img/pinkvert.48ce2c6e.png";